import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const RedoGlyph = /*#__PURE__*/createElement("g", {
  id: "redo"
}, /*#__PURE__*/createElement("path", {
  d: "M68.8 34.3L58.6 24c-.6-.6-1.5-.6-2.1 0-.6.6-.6 1.5 0 2.1l8 8h-8.9c-37 0-40.9 17.3-40.9 24.7 0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5c0-13.8 13.8-21.7 37.9-21.7h8.8l-8 8c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0L68.8 37c.8-.7.8-1.9 0-2.7z"
}));
const Redo = createSvg({
  name: 'redo',
  path: RedoGlyph
});

export default Redo;
export { RedoGlyph };
